module.exports = __webpack_public_path__ + "static/media/48_s1_cam002_2_small.958df060.jpg";